import React, { useState, useEffect } from "react";
import { func, string, number, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";

import Headline from "../../atoms/Headline";
import TextField from "../../atoms/TextField";
import Button from "../../atoms/Button";
import MessageView from "../../atoms/MessageView";
import ProthomFamilyView from "../../atoms/ProthomFamilyView";

import { verifyEmailOtp, verifyEmail, getUser, getJwt } from "../../helper/api";
import { setMember, setLoading, setJwtToken } from "../../helper/actions";
import { staticTexts } from "../../utils/Translate";
import PaloSunLogo from "../../atoms/icons/palo-sunlogo.svg";

import "./otp-verification.m.css";

const OtpVerification = ({
  setMember,
  setLoading,
  setJwtToken,
  navigateToPage,
  authHost,
  integrationsId,
  publisherAttributes
}) => {
  const [error, setError] = useState(null);
  const [otp, setOtp] = useState("");
  const [memberId, setMemberId] = useState(null);
  const lang = publisherAttributes.lang;

  useEffect(() => {
    getUser().then(response => {
      setMemberId(response.member.id);
      verifyEmail(response.member.email);
    });
  }, []);

  const setData = e => {
    // Regex expression to make sure it takes only numbers
    const re = /^[0-9\b]+$/;

    if (!e.target.value || re.test(e.target.value)) {
      setOtp(e.target.value);

      // If error is set remove it since data is changed
      if (error) {
        setError(null);
      }
    }
  };

  const onSubmitClick = event => {
    event.preventDefault();

    if (!otp) {
      setError("Please enter the OTP");
      return;
    }

    setLoading(true);

    verifyEmailOtp(otp, memberId)
      .then(response => {
        setMember(response.member);

        getJwt(integrationsId)
          .then(res => {
            if (res.status === 200) {
              setJwtToken(res.headers["x-integration-token"]);
            }
          })
          .finally(() => navigateToPage("/"));
      })
      .catch(() => setError("Invalid User/OTP"))
      .finally(() => setLoading(false));
  };

  return (
    <form onSubmit={onSubmitClick}>
      <div styleName="container">
        <div styleName="wrapper">
          <Headline text={staticTexts(lang).createAnAccount} headerLevel={3} headlineType={3} />

          <div styleName="content">
            <div styleName="left-content">
              <span styleName="otp-confirmation">{staticTexts(lang).otpconfirmation}</span>

              <TextField
                value={otp}
                placeholder={staticTexts(lang).enterOtp}
                name="name"
                inputType="type2"
                maxLength="6"
                onChange={setData}
              />

              <MessageView type="error" text={error} />

              <Button content={staticTexts(lang).register.toUpperCase()} type="submit" buttonType="type3" />
            </div>

            <div styleName="right-content">
              <img styleName="sun-logo" src={`${assetify(PaloSunLogo)}`} />
              <div styleName="signup-message">
                {staticTexts(lang).OneAccountAll} <br /> {staticTexts(lang).workingForYou}
              </div>
            </div>
          </div>
        </div>
        <div styleName="terms-privacy">
          By proceeding, you agree to the Prothom Alo’s <br /> <a styleName="terms-privacy-link">Terms of Use</a> and{" "}
          <a styleName="terms-privacy-link">Privacy Policy</a>
        </div>
        <ProthomFamilyView />
      </div>
    </form>
  );
};

OtpVerification.propTypes = {
  memberId: string,
  setLoading: func,
  setMember: func,
  navigateToPage: func,
  closeView: func,
  setJwtToken: func,
  authHost: string,
  integrationsId: number,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
    integrationsId: get(state, ["qt", "config", "publisher-attributes", "integrations_id"], null),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

const mapDispatchToProps = dispatch => ({
  setLoading: isLoading => dispatch(setLoading(isLoading)),
  navigateToPage: url => global.app.navigateToPage(dispatch, url),
  setMember: member => dispatch(setMember(member)),
  setJwtToken: token => dispatch(setJwtToken(token))
});

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerification);
